
import React, {
    ReactElement, useEffect, useState,
} from 'react';
import {
    createBrowserRouter, RouteObject, RouterProvider,
} from 'react-router-dom';
import Loadable from '@loadable/component';
import NotFound from '../pages/404';

const Loading = () => (<div>加载中...</div>);

const AsyncComponent = ({ Comp }) => {
    const [element, setElement] = useState<ReactElement>();
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        const Ele = Loadable(Comp);
        setElement(<Ele />);
    }, [Comp]);

    if (!element) {
        return <Loading />;
    }

    return element;
};
const routeList: RouteObject[] = [
  {
    "path": "/",
    "children": [
      {
        "path": "",
        "element": <AsyncComponent Comp={() => import('../pages/index/index')} />
      }
    ]
  }
];
routeList.push(
    {
        "path": "*",
        "element": <NotFound />,
    }
);
const router = createBrowserRouter(routeList);

const Routers = () => <RouterProvider router={router} />;

export default Routers;
        